import React from 'react';

import { useIntl } from 'react-intl-next';

import { IconTile } from '@atlaskit/icon';
import { AssetsIcon, ConfluenceIcon, JiraIcon, TalentIcon } from '@atlaskit/logo';

import { type PrimaryProductKey, PrimaryProductKeys } from '../../../constants/products';

import { i18n } from './messages';

export const FilterProductIcon = (props: {
	primaryProduct?: PrimaryProductKey;
	showPrimaryProductIcon?: boolean;
}) => {
	const { formatMessage } = useIntl();
	const { showPrimaryProductIcon, primaryProduct } = props;

	if (!showPrimaryProductIcon || !primaryProduct) {
		return null;
	}

	if (primaryProduct === PrimaryProductKeys.Confluence) {
		return (
			<IconTile
				size="16"
				icon={() => <ConfluenceIcon shouldUseNewLogoDesign label="" size="xxsmall" />}
				label={formatMessage(i18n.confluenceIconLabel)}
				appearance="blueBold"
			/>
		);
	}

	if (primaryProduct === PrimaryProductKeys.Jira) {
		return (
			<IconTile
				size="16"
				icon={() => <JiraIcon shouldUseNewLogoDesign label="" size="xxsmall" />}
				label={formatMessage(i18n.confluenceIconLabel)}
				appearance="blueBold"
			/>
		);
	}
	if (primaryProduct === PrimaryProductKeys.Assets) {
		return (
			<IconTile
				size="16"
				icon={() => <AssetsIcon shouldUseNewLogoDesign label="" size="xxsmall" />}
				label={formatMessage(i18n.assetsIconLabel)}
				appearance="blueBold"
			/>
		);
	}

	if (primaryProduct === PrimaryProductKeys.Talent) {
		return (
			<IconTile
				size="16"
				icon={() => <TalentIcon shouldUseNewLogoDesign label="" size="xxsmall" />}
				label={formatMessage(i18n.talentIconLabel)}
				appearance="blueBold"
			/>
		);
	}

	// Add more primary product icons here

	return null;
};
